/**
 * User: herbert
 * Date: 20.10.15
 * Time: 19:22
 */

import Reflux from 'reflux';

import stepActions from '../actions/step-actions.js';
import * as stepConfig from '../../../config-steps.js';

import T from '../../../nls/translate.js';

// Idee: fast alles über CSS: Klassen slx-step-<name>  ==> die Step-Component muss die anderen in sich aufnehmen,
//																									  diese anderen müssen ihr aber als Parameter übergeben werden

let hasBeenToParameters = false;

export default Reflux.createStore({
	init: function() {
		this.listenToMany(stepActions);
		this.state = {
			steps: stepConfig.STEPS,
			current: 0,
			substep: null,
			extra: {},
			locked: false
		};
	},
	output: function() {
		this.trigger(this.getInitialState());
	},
	next: function () {
		if (this.state.current === 1 && !hasBeenToParameters) {
			this.signalLocked();
		} else {
			this.state.substep = null;
			this.state.current++;
			if (this.state.current >= this.state.steps.length) {
				this.state.current = this.state.steps.length - 1;
			}
		}
		this.output();
	},
	prev: function() {
		this.state.substep = null;
		this.state.current--;

		if(this.state.current<0) this.state.current = 0;

		this.output();
	},
	switchStep: function(targetName, targetSub) {
		/**@type{Array}*/const steps=this.state.steps;
		let target=-1;
		if(targetName) {
			for (let i = steps.length - 1; i >= 0; i--) {
				if (targetName === steps[i]) {
					target = i;
					break;
				}
			}
		}
		if(target >= 0 &&
			(target !== this.state.current || targetSub !== this.state.substep)
		) {
			if(!hasBeenToParameters && targetName === stepConfig.STEP_PARAMETERS)
				hasBeenToParameters = true;
			this.state.current = target;
			this.state.substep = targetSub;
			this.output();
		}
	},
	switchSubStep: function(substep) {
		if(substep === this.state.substep) return;

		this.state.substep = substep;
		this.output();
	},
	setExtraClass: function(extraDefinition) {
		Object.assign(this.state.extra, extraDefinition);
		this.output();
	},
	signalLocked: function() {
		if(this.lockedTimer) {
			clearTimeout(this.lockedTimer);
		}
		this.lockedTimer = setTimeout(this.timeoutLocked, 500); // must be > fade-in-transition-time
		this.state.locked = true;
		this.output();
	},
	timeoutLocked: function() {
		this.state.locked = false;
		this.output();
	},
	getInitialState: function() {
		const currentStep = this.state.steps[this.state.current];
		let extraClasses = '';
		Object.keys(this.state.extra).forEach(k => {
			if(this.state.extra[k])
			extraClasses += (this.state.extra[k] + ' ');
		}); // das letzte leerzeichen am ende könnte man choppen aber das ist den browsern eh egal
		console.log(currentStep, this.state.substep, extraClasses);
		return {
			name: currentStep,
			title: T.current.STEPS[currentStep],
			substep: this.state.substep,
			extra: extraClasses,
			locked: this.state.locked
		};
	}
});
